var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import apiClient from '@utils/api-client';
const usePostSyncIntegrationStatus = () => {
    const [syncState, setSyncState] = useState('idle');
    const [syncError, setSyncError] = useState(null);
    const syncCategory = (category) => __awaiter(void 0, void 0, void 0, function* () {
        setSyncState('loading');
        setSyncError(null);
        try {
            yield apiClient.post('/integration_statuses/sync', { category });
            setSyncState('idle');
        }
        catch (err) {
            const message = err !== null &&
                typeof err === 'object' &&
                'response' in err &&
                err.response !== null &&
                typeof err.response === 'object' &&
                'data' in err.response &&
                err.response.data !== null &&
                typeof err.response.data === 'object' &&
                'error' in err.response.data &&
                typeof err.response.data.error === 'string'
                ? err.response.data.error
                : 'Failed to queue sync';
            setSyncState('error');
            setSyncError(message);
        }
    });
    return { syncState, syncCategory, syncError };
};
export default usePostSyncIntegrationStatus;
